const swiper = new Swiper('.swiper', {

  // Default parameters
  slidesPerView: 'auto',
  spaceBetween: 10,
  grabCursor: true,

  navigation: false,
  pagination: {
    enabled: false,
    clickable: false,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  loop: true,

  // If we need pagination
  // pagination: {
  //   el: '.swiper-pagination',
  // },

  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },
});
